
<template>
  <div class="contact-info-area bg-f1f5fd">
    <div class="container">
      <div class="contact-info-inner">
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="single-contact-info-box">
              <div class="icon bg1">
                <i class="ph-phone-call"></i>
              </div>
              <h3><a href="tel:+5554992302401">+55 (54) 99230-2401</a></h3>
              <h3><a href="https://wa.me/5554992302401">WhatsApp</a></h3>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="single-contact-info-box">
              <div class="icon">
                <i class="ph-envelope-simple-open"></i>
              </div>
              <h3><a href="mailto:contato@fontes.business">contato@fontes.business</a></h3>
              <h3><a href="mailto:projetos@fontes.business">projetos@fontes.business</a></h3>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="single-contact-info-box">
              <div class="icon bg2">
                <i class="ph-map-pin-line"></i>
              </div>
              <h3>Canela - Rio Grande do Sul, Brasil</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="contact-area ptb-100">
    <div class="container">
      <div class="section-title style-two">
        <span class="sub-title">Fale Conosco</span>
        <h2>Tem alguma dúvida? <br>Vamos conversar!</h2>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="contact-form">
            <form  @submit.prevent>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="form-group">
                    <label>Seu Nome</label>
                    <input type="text" name="name" class="form-control" id="name">
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="form-group">
                    <label>Endereço de E-mail</label>
                    <input type="email" name="email" class="form-control" id="email">
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="form-group">
                    <label>Assunto</label>
                    <input type="text" name="msg_subject" class="form-control" id="msg_subject">
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="form-group">
                    <label>Telefone</label>
                    <input type="text" name="phone_number" class="form-control" id="phone_number">
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>Mensagem...</label>
                    <textarea name="message" id="message" class="form-control" cols="30" rows="5"></textarea>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="checkme">
                    <label class="form-check-label" for="checkme">
                      Aceito os <router-link to="/terms-conditions">Termos de Serviço</router-link> e <router-link to="/privacy-policy">Política de Privacidade</router-link>
                    </label>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <button type="submit" class="btn-style-one red-light-color">Enviar Mensagem  <i class="ph-caret-right"></i></button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
<!--          <div id="maps">-->
<!--            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d445194.6398150985!2d-50.93084842216235!3d-29.36384506772995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951c6b9d8f3f8f07%3A0x4e8f8f8f8f8f8f8f!2sCanela%2C%20RS%2C%20Brazil!5e0!3m2!1sen!2sbd!4v1630302531294!5m2!1sen!2sbd"></iframe>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>